// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__svKgX","left":"InfoRow_left__UUIll"};